import { Box } from '@mui/material';
import { ButtonUI, DialogUI } from '../Interface';
import { CalendarType } from '../../config/taskCalendar';

const SelectDialog = ({ open, handleClose, handleSelectTaskType }) => {
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Objektum választás"
      closeBtn={true}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '500px',
          },
        },
      }}
    >
      <Box mt={2} display="flex" justifyContent="center" gap={2}>
        <ButtonUI
          text="Feladatok"
          className="bg-warning text-xl"
          onClick={() => handleSelectTaskType(CalendarType.SIMPLETASK)}
        />
        <ButtonUI
          text="Feladatlista"
          className="bg-warning text-xl"
          onClick={() => handleSelectTaskType(CalendarType.TASKLIST)}
        />
      </Box>
    </DialogUI>
  );
};

export default SelectDialog;
